<div class="tp-page">
  <h1 class="tp-page-title">{{ message }}</h1>

  <div *ngIf="message !== 'Solde' && message !== 'Profil' && message !== 'Aide'">
    <div class="tp-tabs" role="tablist">
      <button *ngFor="let tab of tabs; let i = index" type="button" role="tab"
        class="tp-tab" [class.is-active]="activeTabIndex === i" (click)="selectTab(i)">
        {{ tab }}
      </button>
    </div>

    <app-beneficiaire *ngIf="activeTabIndex === 0"></app-beneficiaire>
    <app-commandes [type]="messageDuParent('Mint')" *ngIf="activeTabIndex === 1"></app-commandes>
    <app-commandes [type]="messageDuParent('Transfer')" *ngIf="activeTabIndex === 2"></app-commandes>
    <app-commandes [type]="messageDuParent('Burn')" *ngIf="activeTabIndex === 3"></app-commandes>
    <app-parametres *ngIf="activeTabIndex === 4"></app-parametres>
  </div>

  <div *ngIf="message === 'Solde'"><app-solde></app-solde></div>
  <div *ngIf="message === 'Profil'"><app-profil></app-profil></div>
  <div *ngIf="message === 'Aide'"><app-aide></app-aide></div>
</div>